import React, { useEffect } from "react";
import Routes from "./Routes";

function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const hash = String(window.location.hash || '');
    if (!hash) return;

    const lowered = hash.toLowerCase();
    const hasOAuthTokens =
      lowered.includes('access_token=') ||
      lowered.includes('refresh_token=') ||
      lowered.includes('provider_token=') ||
      lowered.includes('expires_at=') ||
      lowered.includes('token_type=') ||
      lowered.includes('error=');

    if (!hasOAuthTokens) return;

    try {
      const nextUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState({}, document.title, nextUrl);
    } catch {
      // ignore
    }
  }, []);

  return (
    <Routes />
  );
}

export default App;
